<template>
	<div>
		<SideBar class="text-white" />
		<!-- <div class="bg-brand-black h-screen w-screen text-white px-6"> -->
		    <div class="bg-black h-screen w-screen text-white px-6">
			<div class="flex justify-center items-center h-screen flex-col">
				<img id="anim-1" src="../assets/logo.png" alt="image-logo" />
				<h3 id="anim-2" class="text-white text-lg  text-center">
					BASTIONARCH CONSULTS - Build Safe, Scale High...
				</h3>

				<div class="mt-12 space-y-6">
					<div class="text-center">
						<h4 class="text-white text-base mb-4 opacity-90">Explore Our Services</h4>
					</div>

					<div class="grid grid-cols-2 gap-4 max-w-md mx-auto">
						<router-link to="/About">
							<button
								class="w-full bg-brand-black border-2 border-brand-yellow hover:bg-brand-yellow hover:text-brand-black px-4 py-3 text-sm font-medium transition-all duration-300"
							>
								About Us
							</button>
						</router-link>

						<router-link to="/Services">
							<button
								class="w-full bg-brand-black border-2 border-brand-yellow hover:bg-brand-yellow hover:text-brand-black px-4 py-3 text-sm font-medium transition-all duration-300"
							>
								Services
							</button>
						</router-link>

						<router-link to="/Portfolio">
							<button
								class="w-full bg-brand-black border-2 border-brand-yellow hover:bg-brand-yellow hover:text-brand-black px-4 py-3 text-sm font-medium transition-all duration-300"
							>
								Portfolio
							</button>
						</router-link>

						<router-link to="/Contact">
							<button
								class="w-full bg-brand-black border-2 border-brand-yellow hover:bg-brand-yellow hover:text-brand-black px-4 py-3 text-sm font-medium transition-all duration-300"
							>
								Contact
							</button>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import SideBar from "@/components/SideBar.vue";
export default {
	name: "Home",
	components: { SideBar },
	computed: {
		...mapActions(["getAllMenu"]),
	},
	mounted() {
		this.getAllMenu;
	},
};
</script>

<style lang="css" scoped>
#anim-1 {
	animation: fadeIn 1s ease-in both;
}

#anim-2 {
	animation: fadeIn 2s ease-in both;
}

#anim-3 {
	animation: fadeIn 3s ease-in both;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translate3d(0, -20%, 0);
	}
	to {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
}
</style>
